<template>
  <page-view title>
    <div slot="headerContent">
      <search-robot @changeRobotId="onChangeRobotId"></search-robot>
    </div>
    <div :style="{ marginBottom: '10px' }">
      <demo-video-alert name="HuiYuanGuanLi"></demo-video-alert>
    </div>
    <exception-page type="norobot" v-if="!currentRobotId" />
    <a-card :bordered="false" v-if="currentRobotId">
      <!-- 查询模块 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="查询条件">
                <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                  <a-select-option value="2">会员ID</a-select-option>
                  <a-select-option value="1">微信昵称</a-select-option>
                  <a-select-option value="9">微信号</a-select-option>
                  <a-select-option value="8">微信备注</a-select-option>
                  <a-select-option value="11">性别</a-select-option>
                  <a-select-option value="3">上级ID</a-select-option>
                  <a-select-option value="10">机器人ID</a-select-option>
                  <a-select-option value="4">微信ID</a-select-option>
                  <a-select-option value="5">追单号</a-select-option>
                  <a-select-option value="6">省份</a-select-option>
                  <a-select-option value="7">超过多少天未下单</a-select-option>

                  <a-select-option value="12">有下级的用户</a-select-option>
                  <!-- <a-select-option value="13">最后下单时间</a-select-option> -->
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="查询内容">
                <a-input
                  v-model="queryParam.keywords"
                  placeholder="请输入查询内容"
                  v-if="queryParam.search_condition != 11"
                  :disabled="queryParam.search_condition == 12"
                />
                <a-select
                  v-model="queryParam.keywords"
                  placeholder="请选择"
                  allowClear
                  v-if="queryParam.search_condition == 11"
                >
                  <a-select-option value="1">男</a-select-option>
                  <a-select-option value="2">女</a-select-option>
                  <a-select-option value="0">未知</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="会员分组">
                <a-select v-model="queryParam.group_id" placeholder="请选择会员分组" allowClear>
                  <template v-if="isShowGroup">
                    <a-select-option v-for="(item, index) in currentRobotGroupInfoData" :key="index" :value="item.id">{{
                      item.name
                    }}</a-select-option>
                  </template>
                </a-select>
              </a-form-item>
            </a-col>

            <a-drawer
              :width="500"
              title="查询条件"
              placement="right"
              :footer-style="{ textAlign: 'right' }"
              :visible="searchDrawerVisible"
              @close="searchDrawerClose"
            >
              <div class="table-page-search-wrapper">
                <a-form layout="inline">
                  <!-- 查询条件 -->
                  <a-form-item label="查询条件">
                    <a-select v-model="queryParam.search_condition" placeholder="请选择查询条件" allowClear>
                      <a-select-option value="2">会员ID</a-select-option>
                      <a-select-option value="1">微信昵称</a-select-option>
                      <a-select-option value="9">微信号</a-select-option>
                      <a-select-option value="8">微信备注</a-select-option>
                      <a-select-option value="11">性别</a-select-option>
                      <a-select-option value="3">上级ID</a-select-option>
                      <a-select-option value="10">机器人ID</a-select-option>
                      <a-select-option value="4">微信ID</a-select-option>
                      <a-select-option value="5">追单号</a-select-option>
                      <a-select-option value="6">省份</a-select-option>
                      <a-select-option value="7">超过多少天未下单</a-select-option>
                      <a-select-option value="12">有下级的用户</a-select-option>
                      <!-- <a-select-option value="13">最后下单时间</a-select-option> -->
                    </a-select>
                  </a-form-item>
                  <a-form-item label="查询内容">
                    <a-input
                      v-model="queryParam.keywords"
                      placeholder="请输入查询内容"
                      v-if="queryParam.search_condition != 11"
                      :disabled="queryParam.search_condition == 12"
                    />
                    <a-select
                      v-model="queryParam.keywords"
                      placeholder="请选择"
                      allowClear
                      v-if="queryParam.search_condition == 11"
                    >
                      <a-select-option value="1">男</a-select-option>
                      <a-select-option value="2">女</a-select-option>
                      <a-select-option value="0">未知</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- 会员分组 -->
                  <a-form-item label="会员分组">
                    <a-select v-model="queryParam.group_id" placeholder="请选择会员分组" allowClear>
                      <template v-if="isShowGroup">
                        <a-select-option
                          v-for="(item, index) in currentRobotGroupInfoData"
                          :key="index"
                          :value="item.id"
                          >{{ item.name }}</a-select-option
                        >
                      </template>
                    </a-select>
                  </a-form-item>
                  <!-- 总订单数≥ -->
                  <a-form-item label="总订单数≥">
                    <a-input v-model="queryParam.total_order" placeholder="请输入" />
                  </a-form-item>
                  <!-- 机器人ID -->
                  <a-form-item label="机器人ID">
                    <a-input v-model="queryParam.robot_id" placeholder="请输入" />
                  </a-form-item>
                  <!-- 交互/下单时间 -->
                  <a-form-item label="交互/下单时间">
                    <a-select v-model="queryParam.time_condition" placeholder="请选择" allowClear>
                      <a-select-option value="1">交互时间</a-select-option>
                      <a-select-option value="2">下单时间</a-select-option>
                    </a-select>
                  </a-form-item>
                  <!-- 时间范围(天) -->
                  <a-form-item label="时间范围(天)">
                    <a-input v-model="queryParam.time_keywords" placeholder="请输入" />
                  </a-form-item>
                </a-form>
              </div>
              <template #footer>
                <a-button style="margin-right: 8px" @click="searchDrawerClose">取消</a-button>
                <a-button type="primary" @click="searchDrawerBtn">查询</a-button>
                <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
              </template>
            </a-drawer>

            <a-col :md="6" :sm="24">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button type="primary" style="margin-left: 8px" @click="searchDrawerShow">高级查询</a-button>
              <a-button style="margin-left: 8px" @click="() => (queryParam = {})">重置</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 查询模块结束 -->
      <div class="table-operator">
        <a-popconfirm placement="topLeft" @confirm="handleRefresh">
          <template slot="title">
            <p>您确认要刷新微信好友吗？</p>
          </template>
          <a-button type="primary" :disabled="FansRefreshStatus ? true : false">刷新微信好友</a-button>
        </a-popconfirm>
        <!-- <a-button type="primary">上报黑名单</a-button> -->
        <a-button type="primary" @click="handleAddGroupAll">全部加入群发列表</a-button>

        <a-popover title="请选择要群发的机器人" trigger="click">
          <template slot="content">
            <div style="width: 600px">
              <robot-multiple @change="robotChange" @returnBack="robotReturnBack"></robot-multiple>
              <div class="m_t_15 d_f f_r">
                <a-button type="primary" :disabled="false" @click="handleOneKeyAddGroupAll">开始推送</a-button>
              </div>
            </div>
          </template>
          <a-button type="primary" :disabled="false" class="m_r_15">批量添加全部群发</a-button>
        </a-popover>
        <!-- <a-button type="primary" @click="handleAddGroupSelect">筛选后一键加入群发列表</a-button> -->
        <a-popover title="请选择要群发的机器人" trigger="click">
          <template slot="content">
            <div style="width: 600px">
              <robot-multiple @change="robotChange" @returnBack="robotReturnBack"></robot-multiple>
              <div class="m_t_15 d_f f_r">
                <a-button type="primary" :disabled="false" @click="handleAddGroupSelect">开始推送</a-button>
              </div>
            </div>
          </template>
          <a-button type="primary" :disabled="false" class="m_r_15">筛选后一键加入群发列表</a-button>
        </a-popover>

        <a-popconfirm ok-text="通讯录列表" cancel-text="确认过滤" @confirm="goToWxlist" @cancel="filterate">
          <div slot="title">请先到<a @click="goToWxlist">通讯录列表</a>刷新好友数据，确保好友数据已刷新，然后再进行过滤，避免旧数据影响过滤！！！</div>
          <a-icon slot="icon" type="exclamation-circle" style="color: red"/>
          <a-button type="primary">根据通讯录过滤会员</a-button>
        </a-popconfirm>

        <!-- 将某一选中分组添加到群发列表，选中分组即可，不需要点击查询 -->
        <a-button type="primary" @click="handleAddGroupTheGroup" v-if="queryParam.group_id">
          将该分组加入群发列表
        </a-button>
        <!-- <a-button type="primary">修改分组</a-button> -->
        <a-dropdown v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay">
            <a-menu-item key="2" @click="handleSendMsg">发送微信消息</a-menu-item>
            <a-menu-item key="3" @click="handleFansReg">申请添加好友</a-menu-item>
            <a-menu-item key="4" @click="handleEditGroup">修改会员分组</a-menu-item>
            <a-menu-item key="5" @click="handleAddGroup">加入群发列表</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            批量操作
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
        <div style="width: 200px; margin-top: -3px">
          <a-progress
            v-if="FansRefreshStatus"
            :percent="FansRefreshStatus['progress']"
            size="small"
            :format="percent => parseInt(percent) + '%'"
          />
        </div>
      </div>
      <table-next
        ref="table"
        rowKey="uid"
        :columns="columns"
        :data="loadData"
        :alert="options.alert"
        :rowSelection="options.rowSelection"
        :scroll="{ x: 2000 }"
        :pagination="{
          showQuickJumper: true,
          onChange: () => {
            $refs.table.clearSelected()
          },
        }"
      >
        <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <span slot="nickname" slot-scope="text">
          <a-tooltip :title="text">
            <span v-line-clamp="1">{{ text }}</span>
          </a-tooltip>
        </span>
        <template slot="balance" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input
              style="margin: -5px 0"
              :value="record.editable_data.balance"
              size="small"
              @change="e => handleChange(e.target.value, record, 'balance')"
            />
          </template>
          <template v-else>
            <span>{{ text || 0 | currency('￥') }}</span>
          </template>
        </template>

        <template slot="integral" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input
              style="margin: -5px 0"
              :value="record.editable_data.integral / 100 || 0"
              size="small"
              @change="e => handleChange(e.target.value * 100 || 0, record, 'integral')"
            />
          </template>
          <template v-else>
            <span>{{ text / 100 || 0 | currency('') }}</span>
          </template>
        </template>

        <span slot="qdlastdt" slot-scope="text">
          <span>{{ text ? text : '无签到记录' }}</span>
        </span>
        <span slot="order_date" slot-scope="text">
          <span>{{ text ? text : '无下单记录' }}</span>
        </span>
        <template slot="group_info" slot-scope="text, record">
          <template v-if="record.editable">
            <a-select
              :value="record.editable_data.usertype"
              style="width: 100%"
              size="small"
              @change="e => handleChange(e, record, 'usertype')"
            >
              <template v-if="currentRobotGroupInfoData">
                <a-select-option v-for="item in currentRobotGroupInfoData" :value="item.id" :key="item.id">{{
                  item.name
                }}</a-select-option>
              </template>
            </a-select>
          </template>
          <template v-else>
            <a v-if="!text">未设置</a>
            <span v-line-clamp="1" v-else>{{ text }}</span>
          </template>
        </template>
        <!-- <span slot="wx_id" slot-scope="text">
          <span v-line-clamp="1">{{ text }}</span>
        </span> -->
        <template slot="wx_id" slot-scope="record">
          <a-tooltip v-if="record.showId" title="点击复制"
            ><span @click="doCopy(record.wxid)">{{ record.wxid }}</span></a-tooltip
          >
          <span v-else
            >****************
            <a-button
              @click="handleGetId(record)"
              type="link"
              style="color: rgba(0, 0, 0, 0.65)"
              icon="eye-invisible"
            ></a-button
          ></span>
        </template>
        <template slot="username" slot-scope="record">
          <a-tooltip v-if="record.showId" title="点击复制"
            ><span @click="doCopy(record.username)">{{
              record.username.length > 2 ? record.username : '暂无'
            }}</span></a-tooltip
          >
          <!-- <span @click="doCopy(text)" v-if="text"><a-tooltip title="点击复制">{{ record.username.length>2?record.username:'暂无' }}</a-tooltip></span> -->
          <span v-else
            >****************<a-button
              @click="handleGetId(record)"
              type="link"
              style="color: rgba(0, 0, 0, 0.65)"
              icon="eye-invisible"
            ></a-button
          ></span>
        </template>
        <!-- <span slot="username" slot-scope="record">
          <span v-line-clamp="1">{{ record.username.length>2?record.username:'暂无' }}</span>
        </span> -->
        <template slot="order_sixbit" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input
              style="margin: -5px 0"
              :value="record.editable_data.order_sixbit"
              size="small"
              @change="e => handleChange(e.target.value, record, 'order_sixbit')"
            />
          </template>
          <template v-else>
            <a v-if="!record.order_sixbit || record.order_sixbit == '0'">无</a>
            <span v-else v-line-clamp="1">{{ record.order_sixbit }}</span>
          </template>
        </template>
        <template slot="sex" slot-scope="record">
          <span v-if="record.sex == '1'">
            <a-tag color="blue">男</a-tag>
          </span>
          <span v-else-if="record.sex == '2'">
            <a-tag color="pink">女</a-tag>
          </span>
          <span v-else>
            <a-tag>未知</a-tag>
          </span>
        </template>

        <template slot="region" slot-scope="record">
          <span v-if="record.address">{{ record.province }} {{ record.address }}</span>
          <span v-else>未知</span>
        </template>

        <template slot="first_award" slot-scope="text">
          <span v-if="text == 1">已奖励</span>
          <span v-else>未奖励</span>
        </template>
        <template slot="trjid" slot-scope="text, record">
          <template v-if="record.editable">
            <a-input
              style="margin: -5px 0"
              :value="record.editable_data.trjid"
              size="small"
              @change="e => handleChange(e.target.value, record, 'trjid')"
            />
          </template>
          <template v-else>
            <a v-if="!text || text == '0'">无</a>
            <span v-else v-line-clamp="1">{{ text }}</span>
          </template>
        </template>
        <span slot="avatar" slot-scope="text">
          <a-avatar shape="square" size="small" icon="user" :src="text" />
        </span>
        <template slot="action" slot-scope="text, record">
          <div class="editable-row-operations">
            <span v-if="record.editable">
              <a @click="() => save(record)">保存</a>
              <a-divider type="vertical" />
              <a-popconfirm title="真的放弃编辑吗?" @confirm="() => cancel(record)">
                <a>取消</a>
              </a-popconfirm>
            </span>
            <span v-else>
              <!--              <a @click="() => edit(record)">修改</a>-->
              <!--              <a-divider type="vertical" />-->
              <a @click="$refs.detaildrawer.show(record.sub_id, record.uid)">编辑查看</a>
              <a-divider type="vertical" />
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item @click="handleSendMsgByWxid(record.sub_id, record.wwid)">发送微信消息</a-menu-item>
                  <a-menu-item @click="resetzfbInfo(record)">重置支付宝信息</a-menu-item>
                  <a-menu-item @click="handleAddBlacklist(record)">加入黑名单</a-menu-item>
                  <a-menu-item @click="handleDelGrouplist(record)">删除所在群组</a-menu-item>
                  <!-- 新增三项功能 -->
                  <a-menu-item @click="goToWidthDrawDetail(record)">提现详情</a-menu-item>
                  <a-menu-item @click="handleFansOrder(record)">订单详情</a-menu-item>
                  <a-menu-item @click="goToPropertyLog(record)">财产日志</a-menu-item>
                  <a-menu-item @click="getDownFans(record)">查看下级</a-menu-item>
                  <a-menu-item @click="delFans(record)">删除</a-menu-item>
                </a-menu>
                <a>
                  更多
                  <a-icon type="down" />
                </a>
              </a-dropdown>
            </span>
          </div>
        </template>
      </table-next>
    </a-card>
    <detail-drawer @refresh="$refs.table.refresh()" ref="detaildrawer"></detail-drawer>
    <send-msg-modal ref="sendMsgModal" @ok="$refs.table.clearSelected()"></send-msg-modal>
    <add-blacklist-modal ref="addBlacklistModal" @ok="$refs.table.refresh()"></add-blacklist-modal>
    <edit-group-modal ref="editGroupModal" @ok="$refs.table.refresh()"></edit-group-modal>
    <del-group-modal ref="delGroupModal" @ok="$refs.table.refresh()"></del-group-modal>
    <reset-modal ref="resetModal" @ok="$refs.table.refresh()"></reset-modal>
    <order-list-modal ref="orderListModal"></order-list-modal>
    <progress-bar ref="progressbar"></progress-bar>
  </page-view>
</template>

<script>
import { TableNext, ExceptionPage } from '@/components'
import SearchRobot from '@/views/components/SearchRobot'
import FansApi from '@/api/fans'
import { PageView } from '@/layouts'
import { mapActions, mapGetters } from 'vuex'
import RobotMultiple from '@/views/components/RobotMultiple'
// 订单详情
import OrderListModal from '@/views/fans/order/OrderListModal'
import DetailDrawer from '@/views/fans/detail/drawer'
import SendMsgModal from './modules/SendMsgModal'
import EditGroupModal from './modules/EditGroupModal'
import AddBlacklistModal from './modules/AddBlacklistModal'
import DelGroupModal from './modules/DelGroupModal'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import ResetModal from './modules/ResetModal.vue'
import ProgressBar from './modules/ProgressBar'

import GrouppushApi from '@/api/grouppush'
import { message } from 'ant-design-vue'
// import { Console } from 'console'
export default {
  name: 'FansList',
  components: {
    PageView,
    TableNext,
    SearchRobot,
    ExceptionPage,
    DetailDrawer,
    SendMsgModal,
    AddBlacklistModal,
    EditGroupModal,
    DelGroupModal,
    DemoVideoAlert,
    ResetModal,
    OrderListModal,
    RobotMultiple,
    ProgressBar,
  },
  data() {
    return {
      isShowGroup: false,
      currentRobotId: null,
      mdl: {},
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          title: '机器人ID',
          width: 100,
          checked: true,
          dataIndex: 'sub_id',
        },
        {
          title: 'UID',
          width: 80,
          checked: true,
          dataIndex: 'uid',
          sorter: true,
        },
        {
          title: '微信ID',
          width: 200,
          scopedSlots: { customRender: 'wx_id' },
        },
        {
          title: '微信昵称',
          dataIndex: 'nickname',
          width: 200,
          checked: true,
          scopedSlots: { customRender: 'nickname' },
        },
        {
          title: '微信号',
          width: 200,
          checked: true,
          scopedSlots: { customRender: 'username' },
        },
        {
          title: '备注',
          dataIndex: 'mark',
          width: 200,
          scopedSlots: { customRender: 'nickname' },
        },
        {
          title: '头像',
          dataIndex: 'avatar',
          width: 80,
          scopedSlots: { customRender: 'avatar' },
        },

        {
          title: '性别',
          width: 100,
          scopedSlots: { customRender: 'sex' },
        },
        {
          title: '省份',
          width: 100,
          dataIndex: 'province',
        },
        {
          title: '城市',
          width: 100,
          dataIndex: 'address',
        },
        {
          title: '标签',
          width: 100,
          dataIndex: 'tag',
        },
        {
          title: '分组类型',
          dataIndex: 'user_group_info.name',
          width: 150,
          checked: true,
          scopedSlots: { customRender: 'group_info' },
        },
        {
          title: '余额',
          sorter: true,
          width: 100,
          checked: true,
          dataIndex: 'balance',
          scopedSlots: { customRender: 'balance' },
        },
        {
          title: '上级ID',
          dataIndex: 'trjid',
          width: 100,
          scopedSlots: { customRender: 'trjid' },
        },
        {
          title: '支付宝账号',
          dataIndex: 'alipaynum',
          width: 150,
        },
        {
          title: '支付宝名称',
          dataIndex: 'alipayrealname',
          width: 150,
        },
        {
          title: '追单号',
          width: 100,
          scopedSlots: { customRender: 'order_sixbit' },
        },
        {
          title: '总订单数',
          sorter: true,
          width: 100,
          checked: true,
          dataIndex: 'order_num',
        },
        {
          title: '总提现金额',
          sorter: true,
          width: 120,
          checked: true,
          dataIndex: 'withdraw_amount',
        },
        {
          title: '结算返利订单数',
          sorter: true,
          width: 150,
          checked: true,
          dataIndex: 'finished_orders_number',
        },
        {
          title: '结算返利金额',
          sorter: true,
          width: 150,
          checked: true,
          dataIndex: 'finished_amount',
        },
        {
          title: '订单总佣金',
          width: 150,
          checked: true,
          dataIndex: 'TotalCommission',
        },
        {
          title: '盈利金额',
          width: 150,
          checked: true,
          dataIndex: 'ProfitAmount',
        },
        {
          title: '未收货订单数',
          sorter: true,
          width: 150,
          checked: true,
          dataIndex: 'pay_orders_number',
        },
        {
          title: '未收货金额',
          sorter: true,
          width: 150,
          checked: true,
          dataIndex: 'pay_amount',
        },
        {
          title: '最后下单时间',
          dataIndex: 'order_date',
          width: 150,
          checked: true,
          sorter: true,
          scopedSlots: { customRender: 'order_date' },
        },
        {
          title: '最后交互时间',
          dataIndex: 'update_time',
          width: 150,
          checked: true,
        },

        {
          title: '签到次数',
          dataIndex: 'qdcount',
          width: 120,
          sorter: true,
        },
        {
          title: '最后签到时间',
          dataIndex: 'qdlastdt',
          width: 150,
          sorter: true,
          scopedSlots: { customRender: 'qdlastdt' },
        },
        {
          title: '注册时间',
          dataIndex: 'regtime',
          width: 150,
        },
        {
          title: '首单奖励',
          dataIndex: 'first_award',
          scopedSlots: { customRender: 'first_award' },
          width: 150,
        },
        {
          title: '进阶奖励一',
          dataIndex: 'jinjie1',
          scopedSlots: { customRender: 'first_award' },
          width: 150,
        },
        {
          title: '进阶奖励二',
          dataIndex: 'jinjie2',
          scopedSlots: { customRender: 'first_award' },
          width: 150,
        },
        {
          title: '进阶奖励三',
          dataIndex: 'jinjie3',
          scopedSlots: { customRender: 'first_award' },
          width: 150,
        },
        {
          title: '所属群wxid',
          dataIndex: 'groupwxid',
          width: 150,
        },
        {
          title: '所属群昵称',
          dataIndex: 'groupname',
          width: 150,
        },
        {
          title: '邀请码',
          dataIndex: 'invite_code',
          width: 150,
        },

        // {
        //   title: '积分',
        //   sorter: true,
        //   width: 100,
        //   dataIndex: 'integral',
        //   scopedSlots: { customRender: 'integral' }
        // },
        {
          title: '操作',
          width: '175px',
          fixed: 'right',
          checked: true,
          scopedSlots: { customRender: 'action' },
        },
      ],
      // 机器人列表
      robotList: [],
      robotListS: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 分组数据
      groupInfoData: {},
      // custom table alert & rowSelection
      options: {
        alert: {
          show: true,
          clear: () => {
            this.selectedRowKeys = []
          },
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange,
        },
      },
      uids: [],
      selectList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return FansApi.getFansList(
          Object.assign(parameter, this.queryParam, {
            sub_id: this.currentRobotId,
            robot_id: this.queryParam.search_condition == '10' ? this.queryParam.keywords : this.queryParam.robot_id,
          })
        ).then(res => {
          res.data.forEach(val => {
            val.editable = false
            val.showId = false
            val.editable_data = {}
          })
          if (res.code === 10000) {
            this.$message.error(res.msg)
          }
          return res
        })
      },
      searchDrawerVisible: false, // 查询条件的抽屉是否可见
      total: 0, // 数据总量total
      batchSize: 300, // 每批向接口发送的数据量
      currentIndex: 0, // 当前发送的数据索引
      sendBatchNum: 0, // 调用次数
    }
  },
  computed: {
    currentRobotGroupInfoData() {
      const currentRobotId = this.currentRobotId
      const groupInfoData = this.groupInfoData
      return groupInfoData[currentRobotId]
    },
    FansRefreshStatus() {
      const robotid = this.currentRobotId
      const fun = this.getRobotFansRefreshStatusById()
      const data = fun(robotid)
      if (data && data['conduct']) {
        return data
      } else {
        return false
      }
    },
  },
  methods: {
    ...mapActions(['WEBSOCKER_ACTIONS_SENDROBOTMSG', 'demoSetVideo', 'TaskDrawerSwitch', 'BatchpushTask']),
    ...mapGetters(['getRobotFansRefreshStatusById']),
    // 新增三项功能
    // 跳转财产日志
    goToPropertyLog(record) {
      const { uid } = record
      this.$router.push({ name: 'CapitalLog', params: { uid: uid } })
    },
    
    // 跳转通讯录列表
    goToWxlist(){
      this.$router.push({ name: 'FansWxlist' })
    },

    // 打开订单详情
    handleFansOrder(record) {
      const { uid } = record
      if (record) {
        this.$refs.orderListModal.show({
          robotid: this.currentRobotId,
          uid: uid,
        })
      }
    },
    // 跳转提现详情
    goToWidthDrawDetail(record) {
      const { uid } = record
      this.$router.push({
        name: 'CapitalList',
        params: { uid: uid },
      })
    },
    handleGetId(record) {
      const hide = this.$message.loading('加载中...')
      FansApi.getMemberId(record)
        .then(res => {
          if (res.code == 1) {
            record.showId = true
            record.wxid = res.data.wxid
            record.username = res.data.username
            this.$message.success('获取成功')
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(res => {
          hide()
        })
    },
    doCopy(text) {
      this.$copyText(text)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch(e => {
          // console.log(`复制错误：`, e)
          this.$message.error('复制失败')
        })
    },
    onChangeRobotId(id) {
      this.isShowGroup = false
      this.currentRobotId = id
      // console.log('当前拉取的是哪个机器人=', this.currentRobotId)
      if (this.$refs.table) {
        this.$refs.table.refresh(true)
      }
      // 获取分组
      FansApi.getGroupList({ sub_id: id })
        .then(res => {
          this.groupInfoData[id] = res.data
        })
        .finally(() => {
          this.isShowGroup = true
        })
    },
    // 会员详情
    handleFansDetail(id) {
      this.$router.push({ path: `/fans/detail/${this.currentRobotId}/${id}` })
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: true,
            clear: () => {
              this.selectedRowKeys = []
            },
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange,
          },
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null,
        }
        this.optionAlertShow = false
      }
    },
    // 高级查询
    superSearch() {
      this.$refs.searchDrawer.show()
    },
    // 展开/收起-搜索模块
    // toggleAdvanced() {
    //   this.advanced = !this.advanced
    // },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    handleDelete(id) {
      this.$refs.table.refresh()
    },
    edit(row) {
      row.editable = true
      row.editable_data = {
        balance: row.balance,
        usertype: row.usertype,
        trjid: row.trjid,
        integral: row.integral,
        order_sixbit: row.order_sixbit,
      }
    },
    handleChange(value, record, key) {
      record.editable_data[key] = value
    },
    save(row) {
      const balance = row.editable_data.balance
      const usertype = row.editable_data.usertype
      const trjid = row.editable_data.trjid
      const integral = row.editable_data.integral
      const order_sixbit = row.editable_data.order_sixbit
      const group_info = this.currentRobotGroupInfoData.filter(item => {
        if (item.id == usertype) return item
      })[0]
      row.user_group_info = group_info
      row.balance = balance
      row.usertype = usertype
      row.trjid = trjid
      row.integral = integral
      row.order_sixbit = order_sixbit
      const params = {
        sub_id: row.sub_id,
        uid: row.uid,
        balance: row.balance,
        integral: row.integral / 100,
        usertype: row.usertype,
        trjid: row.trjid,
        order_sixbit: row.order_sixbit,
      }
      FansApi.updateFensInfo(params).then(res => {
        if (res.code === 1) {
          this.$message.success('保存成功')
        } else {
          this.$message.error(res.msg)
        }
      })
      row.editable = false
    },
    cancel(row) {
      row.editable = false
      row.editable_data = {
        balance: row.balance,
        usertype: row.usertype,
        trjid: row.trjid,
      }
    },
    handleSendMsg() {
      const wxids = this.selectedRows.map(item => {
        // console.log(item)
        let wwid = item.wwid
        wwid = wwid.replace(/-/g, 'p')
        wwid = wwid.replace(/\*/g, 'o')
        wwid = wwid.replace(/&/g, 'i')
        wwid = wwid.replace(/\^/g, 'u')
        return window.atob(wwid)
      })
      this.$refs.sendMsgModal.show({ robotid: this.currentRobotId, wxids: wxids })
    },
    handleEditGroup() {
      const uids = this.selectedRows.map(item => {
        return item.uid
      })
      this.$refs.editGroupModal.show({ robotid: this.currentRobotId, uids: uids })
    },
    // 全部加入群发列表--addUserToTask--6191f1b92a41b接口
    handleAddGroupAll() {
      const hide = message.loading('请稍后...')
      GrouppushApi.addUserToTask({
        sub_id: this.currentRobotId,
        push_type: 2,
        member_type: 1,
      })
        .then(res => {
          if (res.code === 1) {
            message.success('操作成功')
          } else {
            message.error(res.msg)
          }
        })
        .finally(() => hide())
    },
    // 将该分组加入群发列表---------start------------------------
    handleAddGroupTheGroup() {
      //#region 
      // console.log('将该分组加入群发列表==', this.queryParam)
      // FansApi.getFansList(
      //   Object.assign({ pageSize: 999999 }, this.queryParam, {
      //     sub_id: this.currentRobotId,
      //   })
      // ).then(res => {
      //   res.data.forEach(val => {
      //     val.editable = false
      //     val.showId = false
      //     val.editable_data = {}
      //   })
      //   let uids = res.data.map(item => {
      //     return item.uid
      //   })
      //   let index = 0
      //   let sortUids = []
      //   let code = 1

      //   debugger
      //   console.log('uids=',uids);

      //   while (index < uids.length) {
      //     sortUids.push(uids.slice(index, (index += 40)))
      //   }
      //   // const hide = message.loading('请稍后...')
      //   console.log('sortUids=',sortUids);
      //   sortUids.forEach(item => {
      //     GrouppushApi.addUserToTask({
      //       sub_id: this.currentRobotId,
      //       push_type: 1,
      //       member_ids: item,
      //       member_type: 1,
      //     }).then(res => {
      //       code *= res.code
      //     })
      //   })
      //   if (code === 1) {
      //     message.success('操作成功')
      //   } else {
      //     message.error(res.msg)
      //   }
      // })
      //#endregion
      GrouppushApi.addGroupToTask({
        sub_id: this.currentRobotId,
        push_type: 1,
        member_type: 1,
        group_id: this.queryParam.group_id,
      }).then(res => {
        if (res.code === 1) {
          message.success('操作成功')
        } else {
          message.error(res.msg)
        }
      })
    },
    
    // 过滤会员列表，然后将过滤好的数据传给后端
    filterate(){
      FansApi.filterFansList({
        sub_id: this.currentRobotId
      })
        .then(res=>{
          if(res.code == 1){
            // console.log('res=', res)
            let txlArr = res.data.wx_friends_list
            let hyArr = res.data.member_list
            // arrTemp = 通讯录 + 会员列表中有、通讯录中没有的
            let arrTemp = [...txlArr, ...hyArr].filter((elem, index, self) => {
              return index === self.findIndex((e) => {
                return e.wxid === elem.wxid
              })
            })
            // console.log('arrTemp=', arrTemp)
            let temp = [...arrTemp, ...txlArr]
            let retArr = this.findNumsAppearOnce(temp)
            if(retArr.length != 0){
              this.$refs.progressbar.show()
              // console.log('retArr=', retArr)
              this.sendBatch(retArr)
            }else{
              this.$message.success('数据过滤完毕')
              this.$refs.table.refresh(true)
            }
          }else{
            this.$message.error('数据加载失败')
          }
        })
        .catch(err=>{
          this.$message.error('数据加载失败~')
          console.log(err)
        })
    },

    // 将过滤好的数据发送给后端
    sendBatch(retArr){
      this.sendBatchNum += 1
      this.total = retArr.length
      // 当前批次发送的结束索引
      const endIndex = Math.min(this.currentIndex + this.batchSize, this.total)
      // 获取当前批次发送的数据
      const batchData = retArr.slice(this.currentIndex, endIndex)
      let retStr = ''
      batchData.forEach(item => {
        retStr = retStr + item.wxid + ','
      })
      // 将过滤好的数据传给后端
      FansApi.filterFansData({
        sub_id: this.currentRobotId,
        member_ids: retStr
      })
        .then(res=>{
          if(res.code == 1){
            this.currentIndex = endIndex // 更新当前发送的数据索引
            if(this.currentIndex < this.total){
              this.sendBatch(retArr)
            }else{
              this.$refs.progressbar.hide()
              this.$message.success('过滤完毕')
              this.currentIndex = 0
              setTimeout(()=>{
                this.$refs.table.refresh(true)
              },500)
            }
          }else{ 
            this.$message.error('过滤失败，请重新过滤~')
            console.log(err)
          }
        })
        .catch(err=>{
          this.$message.error('过滤失败，请重新过滤~')
          console.log(err)
        })
    },

    handleAddGroup() {
      const uids = this.selectedRows.map(item => {
        return item.uid
      })
      const hide = message.loading('请稍后...')
      GrouppushApi.addUserToTask({
        sub_id: this.currentRobotId,
        push_type: 1,
        member_ids: uids,
        member_type: 1,
      })
        .then(res => {
          if (res.code === 1) {
            message.success('操作成功')
          } else {
            message.error(res.msg)
          }
        })
        .finally(() => hide())
    },
    handleSendMsgByWxid(subId, wwid) {
      // console.log(wwid)
      wwid = wwid.replace(/-/g, 'p')
      wwid = wwid.replace(/\*/g, 'o')
      wwid = wwid.replace(/&/g, 'i')
      wwid = wwid.replace(/\^/g, 'u')
      this.$refs.sendMsgModal.show({ robotid: subId, wxids: [window.atob(wwid)] })
    },
    handleRefresh() {
      this.WEBSOCKER_ACTIONS_SENDROBOTMSG({
        robotid: this.currentRobotId,
        type: 'refreshlist',
        data: {},
      }).then(result => {
        this.$message.success('发送指令成功')
      })
    },
    handleFansReg() {
      const that = this
      this.$confirm({
        title: '申请添加好友',
        content: '确定要向选中的会员发起添加好友申请',
        onOk() {
          const wxids = that.selectedRows.map(item => {
            return item.wxid
          })
          that
            .WEBSOCKER_ACTIONS_SENDROBOTMSG({
              robotid: that.currentRobotId,
              type: 'RequestFansReg',
              data: {
                wxids,
              },
            })
            .then(result => {
              that.$message.success('发送指令成功')
            })
        },
        onCancel() {},
      })
    },
    // 加入黑名单
    handleAddBlacklist(data) {
      // 加入黑名单前自动获取wxid
      FansApi.getMemberId(data)
        .then(res => {
          if (res.code == 1) {
            data.showId = true
            data.wxid = res.data.wxid
            data.username = res.data.username
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(res => {
          this.$refs.addBlacklistModal.show(this.currentRobotId, data)
        })
    },
    handleDelGrouplist(data) {
      // console.log(data.uid, data.sub_id)
      this.$refs.delGroupModal.show(data)
    },
    resetzfbInfo(data) {
      this.$refs.resetModal.show(data)
    },
    // 获取下级列表
    getDownFans(data) {
      this.queryParam.search_condition = 3
      this.queryParam.keywords = data.uid
      this.$refs.table.refresh(true)
      // this.queryParam = {}
    },

    // 删除会员
    delFans({ sub_id, uid }){
      let params = {
        uid: uid,
        sub_id: sub_id,
      }
      FansApi.delFans(params)
        .then(res => {
          if(res.code == 1){
            that.$message.success('删除成功')
            this.$refs.table.refresh(true)
          }
        })
    },

    // robotReturnBackS(List){
    //   this.robotListS = Array.from(List)
    // },
    // robotChangeS(List){
    //   this.robotListS = Array.from(List)
    // },
    //筛选出来的加入群发列表
    handleAddGroupSelect() {
      // console.log('会员列表--查询条件', this.queryParam)
      this.BatchpushTask({
        robotids: this.robotList,
        descs: '加入群发列表',
        apiFun: sub_id => {
          return new Promise(async (resolve, reject) => {
            const res = await FansApi.selectList({
              page: this.queryParam.page,
              size: this.queryParam.size,
              sub_id: this.currentRobotId,
              typestatus: 1,
              robot_id: sub_id,
              keywords: this.queryParam.keywords,
              search_condition: this.queryParam.search_condition,
              total_order: this.queryParam.total_order, // “总订单数（total_order）”筛选条件
              time_condition: this.queryParam.time_condition, // “交互/下单时间”筛选条件
              time_keywords: this.queryParam.time_keywords, // “交互/下单时间”筛选条件--对应的值
              group_id:this.queryParam.group_id
            })
            // resolve(this.$message.success('加入成功'))
            resolve(res)
            this.$message.success('加入成功')
          })
        },
      })

      // FansApi.selectList(
      //     Object.assign(this.queryParam, {
      //       sub_id: this.currentRobotId,
      //       typestatus:1,
      //       robot_id: this.currentRobotId
      //     })
      //   ).then(res => {
      //     if(res.code===1){
      //       this.$message.success("加入成功")
      //     }
      //     if(res.code === 10000){
      //       this.$message.error("加入失败")
      //     }
      //     return res
      //   })
    },
    robotReturnBack(List) {
      this.robotList = Array.from(List)
    },
    robotChange(List) {
      this.robotList = Array.from(List)
    },
    // 批量添加全部群发--addUserToTask--6191f1b92a41b接口
    handleOneKeyAddGroupAll() {
      this.BatchpushTask({
        robotids: this.robotList,
        descs: '添加群发任务',
        apiFun: sub_id => {
          return new Promise(async (resolve, reject) => {
            const res = await GrouppushApi.addUserToTask({
              sub_id: sub_id,
              push_type: 2,
              member_type: 1,
            })
            resolve(res)
          })
        },
      })
      this.TaskDrawerSwitch({ status: true })
    },

    // 查询的抽屉
    // 关闭抽屉
    searchDrawerClose() {
      this.searchDrawerVisible = false
    },
    // 展示抽屉
    searchDrawerShow() {
      this.searchDrawerVisible = true
    },
    // 查询按钮
    searchDrawerBtn() {
      // console.log('点击抽屉的查询')
      this.$refs.table.refresh(true)
      this.searchDrawerVisible = false
    },

    // 找出数组中只出现过一次的元素
    findNumsAppearOnce(array) {
      let res = []
      for (let i = 0; i < array.length; i++) {
        if (array.indexOf(array[i]) === array.lastIndexOf(array[i])) {
          res.push(array[i])
        }
      }
      return res
    }

  },
}
</script>
<style lang="less" scoped>
.table-operator {
  display: flex;
  flex-direction: row;
  align-items: center;
}
/deep/ .page-header {
  .extra {
    display: none;
  }
  .headerContent {
    flex: 0 1 100% !important;
  }
}
.m_t_15 {
  margin-top: 15px;
}
.d_f {
  display: flex;
}
.f_r {
  justify-content: flex-end;
}
</style>
